import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21.836 16.744"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M4.477 0 0 4.246l4.473 4.29 1.384-1.444-2.001-1.918h10.813c1.795 0 3.044.56 3.88 1.404s1.288 2.016 1.288 3.381c0 1.387-.45 2.556-1.286 3.395s-2.084 1.39-3.882 1.39H4.515v2h10.154c2.224 0 4.057-.731 5.3-1.98s1.867-2.974 1.867-4.805c0-1.815-.623-3.536-1.865-4.79-1.241-1.252-3.075-1.995-5.302-1.995H4.038L5.854 1.45z" }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "return"}) } }